import { Link } from 'react-router-dom';

export default function AboutPage() {
  const publications = [
    {
      title: 'PNAS Publication',
      journal: 'Proceedings of the National Academy of Sciences',
      date: 'August 2025',
      url: 'https://www.pnas.org/doi/10.1073/pnas.2514151122'
    },
    {
      title: 'Nature Communications',
      journal: 'Nature Communications',
      date: 'January 2025',
      url: 'https://www.nature.com/articles/s41467-024-55382-9'
    },
    {
      title: 'Science Advances',
      journal: 'Science - Science Advances',
      date: 'March 2023',
      url: 'https://www.science.org/doi/10.1126/sciadv.ade7804'
    },
    {
      title: 'Frontiers in Molecular Neuroscience',
      journal: 'Frontiers in Molecular Neuroscience',
      date: 'November 2021',
      url: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC8632625/'
    },
    {
      title: 'Frontiers in Neuroanatomy',
      journal: 'Frontiers in Neuroanatomy',
      date: 'October 2018',
      url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6198076/'
    }
  ];

  const training = [
    {
      title: 'EUPATI: HTA and Life Sciences Scale-up Regulatory Framework',
      organization: 'European Patients Academy',
      icon: 'ri-shield-check-line'
    },
    {
      title: 'EU IP Patent Law for Life Sciences',
      organization: 'Technical University of Denmark (DTU) & Copenhagen Business School',
      icon: 'ri-file-shield-line'
    },
    {
      title: 'Patent Training',
      organization: 'Eisenführ Speiser & Leibniz-Institut für Kristallzüchtung',
      icon: 'ri-lightbulb-line'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      {/* Navigation */}
      <nav className="bg-white/90 backdrop-blur-sm shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="text-lg md:text-2xl font-bold bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent cursor-pointer whitespace-nowrap">
                Dr. Tina Ghelani
              </Link>
            </div>
            {/* Mobile Navigation Links */}
            <div className="flex md:hidden items-center space-x-3 text-xs">
              <Link to="/about" className="text-blue-600 font-medium whitespace-nowrap cursor-pointer">About</Link>
              <Link to="/projects" className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">Experience</Link>
              <Link to="/#services" className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">Services</Link>
            </div>
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/about" className="text-blue-600 font-medium whitespace-nowrap cursor-pointer">About</Link>
              <Link to="/#services" className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">Services</Link>
              <Link to="/projects" className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">Experience</Link>
              <Link to="/#contact" className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">Contact</Link>
              <a 
                href="https://calendar.app.google/6szNfxS4wtq3RLBC7"
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-teal-500 hover:bg-teal-600 text-white px-4 py-2 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                Book Consultation
              </a>
              <a href="https://www.linkedin.com/in/dr-tina-ghelani" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative py-12 bg-gradient-to-r from-blue-900 to-teal-900 text-white">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-2xl md:text-5xl font-bold mb-4">
            About Dr. Tina Ghelani
          </h1>
          <p className="text-sm md:text-xl text-blue-100 max-w-3xl mx-auto">
            Professional training, academic credentials, and research publications
          </p>
        </div>
      </section>

      {/* Recent Publications Section */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h3 className="text-xl md:text-3xl font-bold text-gray-900 mb-3 text-center">
            Recent Publications
          </h3>
          <p className="text-xs md:text-xl text-gray-600 mb-8 text-center max-w-3xl mx-auto">
            Published in prestigious journals including PNAS, Nature Communications, and Science Advances
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {publications.map((pub, index) => (
              <a
                key={index}
                href={pub.url}
                target="_blank"
                rel="noopener noreferrer"
                className="block bg-gradient-to-br from-blue-50 to-teal-50 p-4 rounded-xl hover:shadow-lg transition-shadow cursor-pointer"
              >
                <div className="flex items-start space-x-3">
                  <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-article-line text-lg text-white"></i>
                  </div>
                  <div className="flex-1">
                    <h5 className="text-sm md:text-base font-bold text-gray-900 mb-1">{pub.title}</h5>
                    <p className="text-xs md:text-sm text-gray-600 mb-1">{pub.journal}</p>
                    <p className="text-xs text-gray-500">{pub.date}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Professional Training Section */}
      <section className="py-12 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h3 className="text-xl md:text-3xl font-bold text-gray-900 mb-3 text-center">
            Professional Training
          </h3>
          <p className="text-xs md:text-xl text-gray-600 mb-8 text-center max-w-3xl mx-auto">
            Specialized training in HTA, regulatory frameworks, and patent law for life sciences
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {training.map((item, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-lg">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-xl text-white`}></i>
                  </div>
                  <div className="flex-1">
                    <h5 className="text-sm md:text-base font-bold text-gray-900 mb-2">{item.title}</h5>
                    <p className="text-xs md:text-sm text-gray-600">{item.organization}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Academic Background Section */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h3 className="text-xl md:text-3xl font-bold text-gray-900 mb-8 text-center">
            Academic Background
          </h3>
          
          <div className="space-y-6">
            <div className="bg-gradient-to-r from-blue-50 to-teal-50 p-6 rounded-xl">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-graduation-cap-line text-xl text-white"></i>
                </div>
                <div className="flex-1">
                  <h5 className="text-sm md:text-xl font-bold text-gray-900 mb-2">Doctor of Natural Sciences (Dr. rer. nat)</h5>
                  <p className="text-xs md:text-lg text-gray-700 mb-1">Georg-August-Universität Göttingen</p>
                  <p className="text-xs md:text-base text-gray-600 mb-3">02/2012 - 05/2016 | Göttingen, Germany</p>
                  <div className="space-y-1">
                    <p className="text-xs md:text-sm text-gray-700"><strong>Honors:</strong> Dorothea Schlözer Mentoring Program (Accelerated Female Academic Talent)</p>
                    <p className="text-xs md:text-sm text-gray-700"><strong>Funding:</strong> CNMPB Cluster of Excellence 171 - DFG Research Center 10 Program</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-blue-50 to-teal-50 p-6 rounded-xl">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-microscope-line text-xl text-white"></i>
                </div>
                <div className="flex-1">
                  <h5 className="text-sm md:text-xl font-bold text-gray-900 mb-2">Master of Science in Medical Sciences (M.Sc.)</h5>
                  <p className="text-xs md:text-lg text-gray-700 mb-1">Uppsala University</p>
                  <p className="text-xs md:text-base text-gray-600 mb-3">01/2005 - 2008 | Uppsala, Sweden</p>
                  <p className="text-xs md:text-sm text-gray-700"><strong>Master's Internship:</strong> EMBL, Monterotondo (01/2009 - 09/2009 | Rome/Monterotondo, Italy)</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-blue-50 to-teal-50 p-6 rounded-xl">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-flask-line text-xl text-white"></i>
                </div>
                <div className="flex-1">
                  <h5 className="text-sm md:text-xl font-bold text-gray-900 mb-2">Bachelor of Science in Chemistry, Genetics & Molecular Biology (B.Sc)</h5>
                  <p className="text-xs md:text-lg text-gray-700 mb-1">Osmania University</p>
                  <p className="text-xs md:text-base text-gray-600">01/2008 - 09/2009 | Hyderabad, India</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 bg-gradient-to-r from-blue-600 to-teal-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-xl md:text-3xl font-bold mb-4">
            Ready to Collaborate?
          </h3>
          <p className="text-sm md:text-xl mb-6 text-blue-100 max-w-3xl mx-auto">
            Let's discuss how strategic consulting can help advance your life sciences initiatives
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://calendar.app.google/6szNfxS4wtq3RLBC7"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-blue-600 text-sm md:text-base px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Schedule Consultation
            </a>
            <Link 
              to="/#contact"
              className="border-2 border-white text-white hover:bg-white hover:text-blue-600 text-sm md:text-base px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Send Message
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-xl md:text-2xl font-bold bg-gradient-to-r from-blue-400 to-teal-400 bg-clip-text text-transparent mb-4">
                Dr. Tina Ghelani
              </h4>
              <p className="text-xs md:text-base text-gray-400 mb-4">
                Expert life sciences consulting with neuroscience specialization
              </p>
              <a href="https://www.linkedin.com/in/dr-tina-ghelani" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-2xl"></i>
              </a>
            </div>
            
            <div>
              <h5 className="text-sm md:text-base font-semibold mb-4">Services</h5>
              <ul className="space-y-2 text-xs md:text-base text-gray-400">
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">Strategic Consulting</Link></li>
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">Regulatory Strategy</Link></li>
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">Investment Advisory</Link></li>
              </ul>
            </div>
            
            <div>
              <h5 className="text-sm md:text-base font-semibold mb-4">Quick Links</h5>
              <ul className="space-y-2 text-xs md:text-base text-gray-400">
                <li><Link to="/about" className="hover:text-white transition-colors cursor-pointer">About</Link></li>
                <li><Link to="/projects" className="hover:text-white transition-colors cursor-pointer">Experience</Link></li>
                <li><Link to="/#contact" className="hover:text-white transition-colors cursor-pointer">Contact</Link></li>
                <li>
                  <a 
                    href="https://calendar.app.google/6szNfxS4wtq3RLBC7"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white transition-colors cursor-pointer"
                  >
                    Book Consultation
                  </a>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-xs md:text-base text-gray-400">
            <p>&copy; 2024 Dr. Tina Ghelani. All rights reserved. | <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Powered by Readdy</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
